import type { Player } from '@schibsted-svp/web-player';

export const getIsFloatingFromPlayerConfig = (
  player: Player | undefined
): boolean => {
  try {
    const floating = (
      player as unknown as {
        config?: {
          rawOptions?: { settings?: { jw?: { floating?: unknown } } };
        };
      }
    )?.config?.rawOptions?.settings?.jw?.floating;
    return Boolean(floating);
  } catch (error) {
    console.error(
      'Video Player Plugins:\n',
      "Cannot verify player's floating state.\n",
      error
    );
    return false;
  }
};
